export { default } from './CreditPaymentsSchedule';
